import { extendTailwindMerge } from "tailwind-merge";

// Extend this config in case of conflicts
const twMerge = extendTailwindMerge({
});
export default twMerge 
